import { Http, Env } from 'core';
import { GetApolloConfigParams, GetEmailParams, getResourceParams } from 'types';

// 验证ticket
export const getUidByTicket = () => Http.get(`${Env.APP_OLD_API_ENV}/api/v1/common/GetUidByTicket`);

// 获取资金单位
export const getTimeOrUnit = () => Http.post('fleet/web/format/Dict/getTimeOrUnit');

// Apollo配置服务
export const getApolloConfig = (args: GetApolloConfigParams) => Http.get('https://as.didiglobal.com/ep/as/conf', args);

// 获取email
export const getEmail = (args: GetEmailParams) => Http.get(`${Env.APP_OLD_API_ENV}/api/v1/driver/email`, args);

// 获取司机个人信息
export const getDriverInfo = () => Http.post('/fleet/web/driver/getDriverInfo');

// 获取菜单列表与服务信息
export const getAppPersonalList = (args: { appversion: string, end_type: string }) => Http.get('/fleet/web/signpost/getAppPersonalList', args);

// 获取头像信息
export const getPortraitStatus = (args: { timestamp: number }) => Http.post('/fleet/web/driver/driverPortrait/getPortraitStatus', args);

// 墨西哥车辆页车头是否命中坏账管控
export const debtCheck = () => Http.get(`${Env.APP_OLD_API_ENV}/api/v1/report/appHome/debtCheck`);

// 撮合平台开发入口
export const matchingOpen = () => Http.get(`${Env.APP_OLD_API_ENV}/api/v1/recommend/v2/driver/open`);

// 撮合入口控制
export const matchingEntrance = () => Http.get('/fleet/web/recommend/getDriverMarketEntrance');

// 获取资源位轮播图
export const getMultiFromActivity = (args: { resource_names: string, resource_product_id: number }) => Http.get('/fleet/web/driver/getMultiFromActivity', args);

// 获取资源位
export const getResource = (args: getResourceParams) => Http.postJson('/fleet/web/driver/getResource', args);

// 钱包页小红点
export const debtRedDot = () => Http.get(`${Env.APP_OLD_API_ENV}/api/v1/report/appHome/debtRedDot`);

// 获取用户登录信息
export const getCookie = () => Http.post('/fleet/web/getCookie');

// 钱包首页-获取菜单列表
export const getWalletMenuList = () => Http.get('/fleet/web/report/appHome/walletConfig');

// 触达弹窗信息
export const getMessage = (args: { from_fleetPC: 0 }) => Http.post(`${Env.APP_OLD_API_ENV}/api/v1/msg/messageCenter/getMessage`, args);

// 获取设置列表
export const getSettingList = () => Http.get('/fleet/web/signpost/easyStart/getSettingConfig');

// 个人中心-关于页列表
export const get99LocConfig = () => Http.get('/fleet/web/signpost/easyStart/get99LocConfig');

// 获取功能开关接口(北斗配置)
export const getSwitchSet = () => Http.get('/fleet/web/common/feature/set');

// 存在失活车辆已下架
export const getExpireCar = () => Http.get('/fleet/web/driver/getExpireCar');
